import React, { useState, useEffect, useContext } from "react";
import "../Gallery/Gallery.scss";
import Header from "../../../Shared-Component/Header/Header.jsx";
import Footer from "../../../Shared-Component/Footer/Footer.jsx";
import CampusSlashTitle from "../../../CampusLife/CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle.jsx";
import { AppContext } from "../../../context/AppContext.jsx";
import { toast } from "react-toastify";
import api from "../../../api.js";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Paginator } from "primereact/paginator";

const Gallery = () => {
  const { allGalleryImages } = useContext(AppContext);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(1);

  const groupImagesByPattern = (images) => {
    const layoutOrder = ["top", "banner", "thirdRow", "fourthRow"];
    const limits = {
      top: 4,
      banner: 1,
      thirdRow: 3,
      fourthRow: 3,
    };

    const grouped = [];
    let remaining = [...images];

    while (remaining.length > 0) {
      const group = {};
      layoutOrder.forEach((type) => {
        group[type] = remaining
          .filter((img) => img.layoutType === type)
          .slice(0, limits[type]);
        remaining = remaining.filter(
          (img, i) => !(img.layoutType === type && group[type].includes(img))
        );
      });
      grouped.push(group);
    }
    return grouped;
  };

  const splitRow = (images) => {
    const left = images.filter((img) => img.layoutPosition === "left");
    const right = images.filter((img) => img.layoutPosition === "right");
    return { left, right };
  };

  const groupedLayouts = groupImagesByPattern(allGalleryImages);
  const paginatedGroups = groupedLayouts.slice(first, first + rows);
  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
  };

  return (
    <>
      <Header />
      <div className="campusmaincontainer">
        <div className="campus-container">
          <CampusSlashTitle slashTitle="Gallery" />
          <div className="gallery-container">
            {/* {groupedLayouts.map((group, i) => ( */}
            {paginatedGroups.map((group, i) => (
              <React.Fragment key={i}>
                {/* First Row */}
                {group.top.length > 0 && (
                  <div className="gallery-firstcontainer">
                    {group.top.map((img, j) => (
                      <div key={j} className="gallery-first-img-container">
                        <img
                          src={img.url}
                          alt={`top-${i}-${j}`}
                          className="gallery-first-img"
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* Second Row */}
                {group.banner.length > 0 && (
                  <div className="gallery-secondcontainer">
                    {group.banner.map((img, j) => (
                      <img
                        key={j}
                        src={img.url}
                        alt={`banner-${i}-${j}`}
                        className="gallery-first-img"
                      />
                    ))}
                  </div>
                )}

                {/* Third Row */}
                {group.thirdRow.length > 0 &&
                  (() => {
                    const images = group.thirdRow;

                    if (images.length === 1) {
                      return (
                        <div className="gallery-secondcontainer">
                          <div className="gallery-full-img-container">
                            <img
                              src={`data:${images[0].contentType};base64,${images[0].data}`}
                              alt=""
                              className="gallery-full-img"
                            />
                          </div>
                        </div>
                      );
                    }

                    if (images.length === 2) {
                      return (
                        <div className="gallery-thirdcontainer gallery-half-row">
                          {images.map((img, j) => (
                            <div key={j} className="gallery-half-img-container">
                              <img
                                src={`data:${img.contentType};base64,${img.data}`}
                                alt=""
                                className="gallery-half-img"
                              />
                            </div>
                          ))}
                        </div>
                      );
                    }

                    const { left, right } = splitRow(images);
                    return (
                      <div className="gallery-thirdcontainer">
                        {left.length === 2 && (
                          <div className="gallery-third-subcontainer">
                            {left.map((img, j) => (
                              <div
                                key={j}
                                className="gallery-third-img-container"
                              >
                                <img
                                  src={`data:${img.contentType};base64,${img.data}`}
                                  alt=""
                                  className="gallery-third-img"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                        {right.length === 1 && (
                          <div className="gallery-third-second-img-container">
                            <img
                              src={`data:${right[0].contentType};base64,${right[0].data}`}
                              alt=""
                              className="gallery-third-second-img"
                            />
                          </div>
                        )}
                      </div>
                    );
                  })()}

                {/* Fourth Row */}
                {group.fourthRow.length > 0 &&
                  (() => {
                    const images = group.fourthRow;

                    if (images.length === 1) {
                      return (
                        <div className="gallery-secondcontainer">
                          <div className="gallery-full-img-container">
                            <img
                              src={`data:${images[0].contentType};base64,${images[0].data}`}
                              alt=""
                              className="gallery-full-img"
                            />
                          </div>
                        </div>
                      );
                    }

                    if (images.length === 2) {
                      return (
                        <div className="gallery-fourthcontainer gallery-half-row">
                          {images.map((img, j) => (
                            <div key={j} className="gallery-half-img-container">
                              <img
                                src={`data:${img.contentType};base64,${img.data}`}
                                alt=""
                                className="gallery-half-img"
                              />
                            </div>
                          ))}
                        </div>
                      );
                    }

                    const { left, right } = splitRow(images);
                    return (
                      <div className="gallery-fourthcontainer">
                        {left.length === 1 && (
                          <div className="gallery-third-second-img-container">
                            <img
                              src={`data:${left[0].contentType};base64,${left[0].data}`}
                              alt=""
                              className="gallery-third-second-img"
                            />
                          </div>
                        )}
                        {right.length === 2 && (
                          <div className="gallery-third-subcontainer">
                            {right.map((img, j) => (
                              <div
                                key={j}
                                className="gallery-third-img-container"
                              >
                                <img
                                  src={`data:${img.contentType};base64,${img.data}`}
                                  alt=""
                                  className="gallery-third-img"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })()}
              </React.Fragment>
            ))}
          </div>

          <Paginator
            first={first}
            rows={rows}
            totalRecords={groupedLayouts.length}
            onPageChange={onPageChange}
            rowsPerPageOptions={[1]}
            template="PrevPageLink PageLinks NextPageLink"
          />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Gallery;
